<template>
  <div class="body2">
    <div class="bg"></div>
    <div class="b2">
      <div class="class_top">
        <div class="upload_box" v-if="selectList.length == 0">
          <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
            :show-file-list="false" action class="upload-demo" multiple accept=".xlsx,.xls,.ppt,.pptx,.doc,.docx,.pdf">
            <div class="topright_item">
              <img class="item_img" src="../../assets/img/zy_wjsc@2x.png" />
              <div class="item_txt">文件上传</div>
            </div>
          </el-upload>
          <div class="topright_item1" @click="btn_uploadFileOrLink(1)">
            <img class="item_img" src="../../assets/img/zy_xjwjj@2x.png" />
            <div class="item_txt">新建文件夹</div>
          </div>
        </div>
        <div class="bottommenu" v-if="selectList.length > 0">
          <div class="bottommenu_item" :class="!item.show ? 'bit' : ''" v-for="(item, index) in menuList" :key="index"
            @click="bottomMenuClick(item, index)" v-if="index < 6">
            <img class="menu_img" :src="item.icon" />
            <div class="menu_txt">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="clasalist">
        <img class="jtimg" src="../../assets/img/zy_zjt@2x.png" @click="btn_back" />
        <div style="width: 1px; height: 14px; background-color: #F5F5F5;margin: 10px 10px 20px 20px;"></div>
        <div class="ztList">
          <div v-for="(item, index) in fileRouter" :key="index">{{ item.name }}</div>
        </div>
        <!-- 占位 -->
        <!-- <img class="jtimg1" src="../../assets/img/zy_sx@2x.png" /> -->


      </div>
      <div class="dian">
        <div :class="type == item.type ? 'd2' : 'd1'" v-for="(item, index) in typeList" :key="index"
          @click="btn_type(item.type)">
          {{ item.name }}
        </div>
      </div>
      <div class="list">
        <div class="head">
          <div class="head_left">
            <img class="select" :src="isAll ? require('@/assets/img/i88.png') : require('@/assets/img/i89.png')"
              @click="btn_all" />
            <div class="zw"></div>
            <div class="t1">文件名</div>
          </div>
          <div class="head_left">
            <div class="t2">上传人</div>
            <div class="t2" style="width: 200px;">上传时间</div>
            <div class="t2">文件类型</div>
            <div class="t2">文件大小</div>
          </div>
        </div>
        <div class="item" v-for="(item, index) in list" :key="index" @click="btn_item(item, index)"
          @dblclick="btn_fileRouter(item, index)">
          <div class="head_left">
            <img class="select"
              :src="item.select == 1 ? require('@/assets/img/i88.png') : require('@/assets/img/i89.png')" />
            <img class="zw" :src="fileIcon(item.resourceType, item.path)" />
            <div class="t1 line1_">{{ item.name }}</div>
            <div class="item_tag">{{ item.publicFlag == 0 ? '个人' : '公开' }}</div>
          </div>
          <div class="head_left">
            <div class="t2">{{ item.nickName }}</div>
            <div class="t2" style="width: 200px;">{{ item.createTime }}</div>
            <div class="t2">{{ item.ext }}</div>
            <div class="t2">{{ item.size ? bytesToSize(item.size) : '' }}</div>
          </div>
        </div>
        <noData v-if="list.length == 0"></noData>
      </div>

      <!-- 文件详情 -->
      <div class="fileinfo" v-if="fileinfo">
        <div class="qrbox" style="height: 350px">
          <img class="esc" src="../../assets/img/i18.png" @click="fileinfo = false" />
          <div class="gbbox">
            <div class="qrtitle">
              文件详情
            </div>
            <div class="qrfilename">
              <img class="fileimg" :src="fileIcon(fileInfo.resourceType, fileInfo.path)" />
              <div class="filename line1_">{{ fileInfo.name }}</div>
            </div>
            <div class="nrbox">
              <div style="margin-right: 10px;">
                <div class="nrname">文件类型</div>
                <div class="nrname1">{{ fileInfo.ext }}</div>
              </div>
              <div style="margin-right: 10px;">
                <div class="nrname">文件大小</div>
                <div class="nrname1">{{ bytesToSize(fileInfo.size) }}</div>
              </div>
            </div>
            <div class="nrbox" style="margin-top: 20px;">
              <div style="margin-right: 10px;">
                <div class="nrname">文件上传时间</div>
                <div class="nrname1">{{ fileInfo.createTime }}</div>
              </div>
              <div style="margin-right: 10px;">
                <div class="nrname">最后修改时间</div>
                <div class="nrname1">{{ fileInfo.updateTime || '--' }}</div>
              </div>
            </div>
            <!-- <div class="qrbtnbox">
            下载
          </div> -->
            <!-- <img class="gb" src="../../assets/img/i7.png" @click="fileinfo = false" /> -->
          </div>
        </div>
      </div>
      <!-- 上传链接and文件夹命名 -->
      <div class="updateUrlandReportName" v-if="updateUrlandReportName">
        <div class="qrbox">
          <img class="esc" src="../../assets/img/i18.png" @click="updateUrlandReportName = false" />
          <div class="gbbox">
            <div class="qrtitle">
              {{ !isUploadUrl ? "传链接" : "文件夹命名" }}
            </div>
            <textarea class="input" v-model="createName" :placeholder="!isUploadUrl ? '请粘贴输入地址' : '请输入文件夹名称'" rows="10"
              cols="5"></textarea>
            <div class="btnleft" @click="btn_addFileOrLink">
              确定
            </div>
            <!-- <img class="gb" src="../../assets/img/i7.png" @click="updateUrlandReportName = false" /> -->
          </div>
        </div>
      </div>
      <!-- 重命名 -->
      <div class="updateUrlandReportName" v-if="editFileNamePop">
        <div class="qrbox">
          <img class="esc" src="../../assets/img/i18.png" @click="editFileNamePop = false" />
          <div class="gbbox">
            <div class="qrtitle">重命名</div>
            <textarea class="input" v-model="fileName" placeholder="请输入" rows="10" cols="5"></textarea>
            <div class="btnleft" @click="btn_editFileName">
              确定
            </div>
            <!-- <img class="gb" src="../../assets/img/i7.png" @click="editFileNamePop = false" /> -->
          </div>
        </div>
      </div>
      <!-- 移动 -->
      <div class="movePop" v-if="movePop">
        <div class="mp_box">
          <div class="mpb_top">
            移动到“{{ moveItem.name || '我的个人库' }}”
            <img src="../../assets/img/i18.png" @click="movePop = false" />
          </div>
          <div class="mpb_back" @click="btn_backs">
            <img src="../../assets/img/zy_zjt@2x.png" />
            返回
          </div>
          <div class="mpb_list">
            <div class="pbl_item" v-for="(item, index) in moveList" :key="index" v-if="item.resourceType == 0"
              @click="btn_moveItem(item, index)">
              <img src="../../assets/img/i134.png" />
              {{ item.name }}
            </div>
          </div>
          <div class="mpb_bottom">
            <div class="pbb_btn" @click="movePop = false">取消</div>
            <div class="pbb_btn1" @click="btn_move">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

import axios from 'axios'
import { ossToken, fileResourceList, fileResourceAdd, aiAnalysis, editResource, fileResourceInfo, fileResourceRemove, fileResourcePublic, cancelPublic, transferResource, fileResourceMove } from '@/apis/index'
export default {
  data() {
    return {
      //主题
      btnSelect1: true,
      //公共
      btnSelect2: false,
      //个人
      btnSelect3: false,
      //二维码
      qrcode: false,
      //文件详情
      fileinfo: false,
      //AI报告
      aiReport: false,
      //传链接and文件夹命名
      updateUrlandReportName: false,
      isUploadUrl: false,
      menuList: [
        {
          'icon': require('../../assets/img/zygk@2x.png'),
          'name': '公开',
          show: false,
        },
        {
          'icon': require('../../assets/img/zyxz@2x.png'),
          'name': '下载',
          show: true,
        },
        {
          'icon': require('../../assets/img/zyyd@2x.png'),
          'name': '转存',
          show: true,
        }, {
          'icon': require('../../assets/img/zycmm@2x.png'),
          'name': '重命名',
          show: true,
        }, {
          'icon': require('../../assets/img/zywjxq@2x.png'),
          'name': '文件详情',
          show: true,
        },
        {
          'icon': require('../../assets/img/zysc@2x.png'),
          'name': '删除',
          show: true,
        }, {
          'icon': require('../../assets/img/zyjb@2x.png'),
          'name': '举报',
          show: true,
        },
      ],
      typeList: [{
        name: '主题',
        type: 1
      }, {
        name: '公共',
        type: 2
      }, {
        name: '个人',
        type: 3
      }],
      keyword: '',
      parentId: '',
      resourceType: '',
      sort: 2,
      sortType: '',
      type: 2,
      list: [],
      selectList: [],
      isAll: false,
      myHeaders: { "X-Token": ossToken() },
      createName: '',
      aiInfo: {},
      fileName: '',
      editFileNamePop: false,
      fileInfo: {},
      fileRouter: [],
      moveItem: {},
      moveParentId: '',
      moveList: [],
      movePop: false,
      fileRouters: [{
        id: 0,
        name: '我的个人库'
      }],
    }
  },
  created() {

  },
  mounted() {
    this.getList()
    this.fileRouter = [{ name: this.typeList[this.type - 1].name }]
  },
  methods: {
    //移动功能-提交移动文件请求
    btn_move() {
      var ids = this.selectList.map(item => {
        return item.id
      })
      fileResourceMove({
        idList: ids,
        parentId: this.moveParentId
      }).then(res => {
        console.log(res, 'fileResourceMove');
        this.$message.success('移动成功')
        this.moveParentId = ''
        this.selectList = []
        this.isAll = false
        this.moveItem = {}
        this.menuList.forEach(e => {
          e.flag = false
        })
        this.flag = false
        this.getList()
        this.movePop = false
      })
    },
    //移动功能-点击文件目录
    btn_moveItem(item, index) {
      this.moveItem = item
      this.fileRouters.push(item)
      this.moveParentId = item.id
      this.getFileMoveList()
    },
    // 获取移动文件的文件夹数据
    getFileMoveList() {
      fileResourceList(this.keyword, this.moveParentId, this.resourceType ? Number(this.resourceType) : this
        .resourceType, this.sort, this.sortType, this.type).then(res => {
          console.log(res, 'fileResourceList');
          res.data.forEach(e => {
            e.select = 0
          })
          this.moveList = res.data
        })
    },
    // 移动弹窗-返回上一级目录
    btn_backs() {
      console.log(this.fileRouters, 'fileRouter');
      if (this.fileRouters.length > 1) {
        this.fileRouters.splice(this.fileRouters.length - 1, 1)
        this.moveParentId = this.fileRouters[this.fileRouters.length - 1].id
        this.moveItem = this.fileRouters[this.fileRouters.length - 1]
        this.getFileMoveList()
      }
    },
    fileIcon(resourceType, fileNameOrUrl) {
      // 定义图标的映射
      const icons = {
        0: require('@/assets/img/i134.png'), // 文件夹
        1: this.webImg + fileNameOrUrl + '?x-oss-process=video/snapshot,t_1000,m_fast,w_800', // 视频
        2: this.webImg + fileNameOrUrl, // 图片
        3: this.getDocumentIcon(this.webImg + fileNameOrUrl), // 文档
        4: require('@/assets/img/i135.png'), // 音频
        5: require('@/assets/img/i136.png'), // 链接
        6: require('@/assets/img/i200.png'), // 笔记
        7: require('@/assets/img/ys.png'),
      };

      return icons[resourceType] || ''; // 默认图标
    },
    getDocumentIcon(fileName) {
      // 判断文件扩展名以返回相应的文档图标
      const extension = fileName.split('.').pop().toLowerCase();
      switch (extension) {
        case 'xls':
        case 'xlsx':
          return require('@/assets/img/i201.png'); // Excel 图标
        case 'ppt':
        case 'pptx':
          return require('@/assets/img/i199.png'); // PPT 图标
        case 'doc':
        case 'docx':
          return require('@/assets/img/i108.png'); // Word 图标
        case 'pdf':
          return require('@/assets/img/i137.png'); // PDF 图标
        default:
          return ''; // 默认文档图标
      }
    },
    btn_back() {
      if (this.fileRouter.length > 1) {
        this.fileRouter.splice(this.fileRouter.length - 1, 1)
        this.parentId = this.fileRouter[this.fileRouter.length - 1].id
        this.isAll = false
        this.selectList = []
        this.getList()
      } else {
        this.$message({ type: 'warning', message: '没有上一级目录' })
      }
    },
    btn_fileRouter(item, index) {
      console.log(item, 'item');
      if (item.resourceType == 0) {
        var obj = JSON.parse(JSON.stringify(item))
        obj.name = '>' + obj.name
        this.fileRouter.push(obj)
        this.parentId = item.id
        this.isAll = false
        this.selectList = []
        this.getList()
      }
    },
    btn_editFileName() {
      editResource({
        name: this.fileName,
        id: this.selectList[0].id
      }).then(res => {
        console.log(res, 'editResource');
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.editFileNamePop = false
        this.fileName = ''
        this.getList()
      })
    },
    generateQRCode() {
      if (this.$refs.qrCodeDiv) {
        this.$refs.qrCodeDiv.innerHTML = '';
      }
      new QRCode(this.$refs.qrCodeDiv, {
        text: "123456", // 需要转换为二维码的内容
        width: 160, //宽度
        height: 160, //高度
        colorDark: '#000000', //二维码方块颜色
        colorLight: '#ffffff', //背景颜色
        correctLevel: QRCode.CorrectLevel.Q, //容错率：L M Q H 依次递减
      });
    },
    btn_addFileOrLink() {
      if (this.isUploadUrl) {
        fileResourceAdd({
          name: this.createName,
          resourceType: 0,
          parentId: this.parentId

        }).then(res => {
          console.log(res, 'fileResourceAdd');
          this.getList()
          this.createName = ''
          this.$message({ message: '添加成功', type: 'success' })
          this.updateUrlandReportName = false
          this.isUploadUrl = false
        })
      } else {
        fileResourceAdd({
          name: new Date().getTime() + '上传的链接',
          content: this.createName,
          resourceType: 5,
          parentId: this.parentId

        }).then(res => {
          console.log(res, 'fileResourceAdd');
          this.getList()
          this.createName = ''
          this.$message({ message: '添加成功', type: 'success' })
          this.updateUrlandReportName = false
          this.isUploadUrl = false
        })
      }

    },
    btn_uploadFileOrLink(type) {
      if (type == 1) {
        this.updateUrlandReportName = true
        this.isUploadUrl = true
      } else {
        this.updateUrlandReportName = true
        this.isUploadUrl = false
      }
    },
    downloadFile() {
      // var fileArr = this.selectList.map(item => item.path)
      // console.log(this.selectList[0], 'fileArr');
      // window.open(this.webImg + fileArr[0], '_blank');
      // window.hnAPI.download({url:this.webImg + fileArr[0],name:this.selectList[0].name})
      this.selectList.forEach(item => {
        item.url = this.webImg + item.path
      })
      console.log(this.selectList, 'selectList');
      window.hnAPI.download(this.selectList, (res) => {
        console.log('======:', res.code);
        this.$message({
          type: 'success',
          message: '下载成功'
        })
      });
    },
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl(event) {
      console.log(event, 'eventOnchange');
    },
    validateOfficeFilePath(filePath) {
      const officeFileRegex = /\.(doc|docx|xls|xlsx|ppt|pptx|pdf)$/i;
      if (!filePath || typeof filePath !== 'string') {
        return false;
      }
      return officeFileRegex.test(filePath);
    },
    // 上传
    handleUploadForm(param) {
      const formData = new FormData();
      formData.append("multipart", param.file);
      if (!this.validateOfficeFilePath(param.file.name)) {
        return this.$message({
          type: 'warning',
          message: '仅支持常见文档类型（doc，pptx，xlsx，pdf，docx，pdf ）'
        })
      }
      let loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 获取上传token
      console.log(param.file, 'param');

      ossToken(param.file.name).then(res => {
        let ossRes = JSON.parse(res.data);
        console.log(ossRes, 'getOssToken')
        const ossData = new FormData();
        Object.keys(ossRes).forEach((key) => {
          ossData.append(key, ossRes[key]);
        });
        ossData.append("file", param.file);
        var url = ossRes.host;
        axios({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'post',
          url: url,
          data: ossData
        }).then(async (res2) => {
          console.log(res2, 'ossurl');
          const lastIndex = res2.data.url.lastIndexOf('/');
          const result = res2.data.url.substring(lastIndex + 1);
          const fileExtension = res2.data.url.split('.').pop();
          var resourceType = null;

          if (fileExtension === 'mp4') {
            resourceType = 1;
          } else if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'gif' || fileExtension === 'jpeg') {
            resourceType = 2;
          } else if (fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'xls' || fileExtension === 'xlsx' || fileExtension === 'ppt' || fileExtension === 'pptx' || fileExtension === 'pdf') {
            resourceType = 3;
          } else if (fileExtension === 'mp3' || fileExtension === 'wav' || fileExtension === 'amr' || fileExtension === 'pcm') {
            resourceType = 4;
          }
          // 1.视频、2.图片、3.文档、4.音频
          fileResourceAdd({
            name: param.file.name,
            path: res2.data.url,
            resourceType: resourceType,
            parentId: this.parentId

          }).then(res => {
            console.log(res, 'fileResourceAdd');
            loading.close();
            this.getList()
          })
        })
      })
    },
    btn_all() {
      this.isAll = !this.isAll
      if (this.isAll) {
        this.list.forEach(e => {
          e.select = 1
        })
      } else {
        this.list.forEach(e => {
          e.select = 0
        })
      }
      this.selectList = this.list.filter(item => {
        return item.select == 1
      })
    },
    btn_item(item) {
      item.select = 1 - item.select;
      this.selectList = this.list.filter(item => item.select === 1);

      this.isAll = this.selectList.length === this.list.length;

      const showMenu = this.selectList.length <= 1;
      // 2,
      // 公开，下载，转存，重命名，文件详情，删除，举报
      if (this.type == 3) {
        [3, 4].forEach(index => {
          if (this.menuList[index]) {
            this.menuList[index].show = showMenu;
          }
        });
      } else {
        [4].forEach(index => {
          if (this.menuList[index]) {
            this.menuList[index].show = showMenu;
          }
        });
      }
      if (this.selectList.length > 0 && this.selectList[0].publicFlag == 1 && this.type == 3) {
        this.menuList[0].name = '取消公开'
      } else {
        this.menuList[0].name = '公开'
      }
    },
    bytesToSize(bytes) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) {
        return '0B';
      }
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      if (i === 0) {
        return `${bytes}${sizes[i]}`;
      }
      return `${(bytes / (1024 ** i)).toFixed(1)}${sizes[i]}`;
    },
    getList() {
      fileResourceList(this.keyword, this.parentId, this.resourceType ? Number(this.resourceType) : this
        .resourceType, this.sort, this.sortType, this.type).then(
          res => {
            console.log(res, 'fileResourceList');
            res.data.forEach(e => {
              e.select = 0
            })
            this.list = res.data
            this.parentId = ''
            // this.fileRouter = [{ name: this.typeList[this.type - 1].name }]
            if (this.type == 3) {
              this.menuList[0].show = false
              this.menuList[1].show = true
              this.menuList[3].show = true
            } else {
              this.menuList[0].show = false
              this.menuList[5].show = false
              this.menuList[3].show = false
            }
            this.getFileMoveList()
          })
    },
    btn_type(type) {
      // 公开，下载，转存，重命名，文件详情，删除，举报
      this.type = type
      this.parentId = ''
      this.isAll = false
      this.selectList = []
      this.fileRouter = [{ name: this.typeList[this.type - 1].name }]
      if (this.type == 3) {
        this.menuList[0].show = false
        this.menuList[1].show = true
        this.menuList[2].show = true
        this.menuList[2].name = '移动'
        this.menuList[3].show = true
        this.menuList[4].show = true
        this.menuList[5].show = true
        this.menuList[6].show = true
      } else {
        this.menuList[0].show = false
        this.menuList[1].show = true
        this.menuList[2].show = true
        this.menuList[2].name = '转存'
        this.menuList[3].show = false
        this.menuList[4].show = true
        this.menuList[5].show = false
        this.menuList[6].show = true
      }
      this.getList()
    },
    bottomMenuClick(item, index) {
      // if (this.selectList.length == 0) {
      //   return this.$message.error('请选择文件')
      // }
      if (!item.show) {
        return false
      }
      switch (index) {
        // 公开，下载，转存，重命名，文件详情，删除，举报
        case 0:
          if (this.selectList[0].publicFlag == 0) {
            var list = this.selectList.filter(item => {
              return item.publicFlag == 1
            })
            if (list.length > 0) {
              return this.$message.error('部分文件已公开，请勿重复操作')
            }
            var ids = this.selectList.map(item => {
              return item.id
            })
            fileResourcePublic(ids).then(res => {
              console.log(res, 'fileResourcePublic');
              this.$message({ type: 'success', message: '公开成功' })
              this.getList()
              this.menuList[3].name = '公开'
            })
          } else {
            var list = this.selectList.filter(item => {
              return item.publicFlag == 0
            })
            if (list.length > 0) {
              return this.$message.error('部分文件未公开，请勿重复操作')
            }
            var ids = this.selectList.map(item => {
              return item.id
            })
            cancelPublic(ids).then(res => {
              console.log(res, 'cancelPublic');
              this.$message({ type: 'success', message: '取消公开成功' })
              this.getList()
              this.menuList[3].name = '公开'
            })
          }
          break
        case 1:
          var fileArr = this.selectList.map(item => item.path)
          console.log(this.selectList[0], 'fileArr');
          window.open(this.webImg + fileArr[0], '_blank');
          break
        case 2:
          if (this.type == 3) {
            this.movePop = true
          } else {
            var ids = this.selectList.map(item => {
              return item.id
            })
            transferResource({
              ids: ids,
              parentId: ''
            }).then(res => {
              this.$message({ type: 'success', message: '转存成功' })
              this.getList()
            })
          }
          break
        case 3:
          this.editFileNamePop = true
          break
        case 4:
          fileResourceInfo(this.selectList[0].id).then(res => {
            console.log(res, 'fileResourceInfo');
            this.fileInfo = res.data.fileResource
            this.fileinfo = true
          })
          break
        case 5:
          var ids = this.selectList.map(item => {
            return item.id
          })
          fileResourceRemove(ids).then(res => {
            console.log(res, 'fileResourceRemove');
            this.$message({ type: 'success', message: '删除成功' })
            this.menuList.forEach(e => { e.show = true })
            this.getList()
          })
          break
        case 6:

          break
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line2_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.body2 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;

  .bg {
    width: 100%;
    height: 228px;
    background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .b2 {
    width: 1200px;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // background-color: #fff;
    margin-top: 30px;
  }

  .popup {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .qrcode {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);

    .gbbox {
      position: relative;
      width: 100%;
      height: 100%;

      .gb {
        position: absolute;
        width: 15px;
        height: 15px;
        right: 15px;
        top: 15px;
      }
    }

    .qrbox {
      margin: auto;
      transform: translate(0%, 40%);
      background-color: #FFFFFF;
      border-radius: 7px;
      width: 375px;
      height: 450px;

      .qrtitle {
        width: 100%;
        height: 46px;
        line-height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .qrfilename {
        display: flex;
        height: 64px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        margin: 20px 20px 16px 16px;
        box-sizing: border-box;

        .fileimg {
          padding: 10px;
          width: 44px;
          height: 44px;
        }

        .filename {
          font-size: 14px;
          color: #000000;
          line-height: 64px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .qcode {
        width: 160px;
        height: 160px;
        margin-left: 107px;
      }

      .qrbtnbox {
        margin-top: 80px;
        padding-left: 30px;
        box-sizing: border-box;
        padding-right: 30px;
        width: 100%;
        height: 40px;
        display: flex;
      }

      .btnleft {
        width: 150px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #5AA7F7;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #5AA7F7;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .btnright {
        width: 150px;
        height: 40px;
        background: #5AA7F7;
        box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
        border-radius: 25px 25px 25px 25px;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-left: 16px;
      }
    }
  }

  .fileinfo {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);

    .gbbox {
      position: relative;
      width: 100%;
      height: 100%;

      .gb {
        position: absolute;
        width: 15px;
        height: 15px;
        right: 15px;
        top: 15px;
      }
    }

    .qrbox {
      margin: auto;
      transform: translate(0%, 40%);
      background-color: #FFFFFF;
      border-radius: 7px;
      width: 375px;
      height: 450px;
      position: relative;

      .esc {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        z-index: 4;
      }

      .qrtitle {
        width: 100%;
        height: 46px;
        line-height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .qrfilename {
        display: flex;
        height: 64px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        margin: 20px 20px 16px 16px;
        box-sizing: border-box;

        .fileimg {
          padding: 10px;
          width: 44px;
          height: 44px;
        }

        .filename {
          font-size: 14px;
          color: #000000;
          line-height: 64px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .nrbox {
        padding-left: 15px;
        padding-right: 10px;
        height: 64px;
        display: flex;
        box-sizing: border-box;

      }

      .nrbox>div {
        flex: 1;
        height: 66px;
        background: #F9F9F9;
        border-radius: 5px 5px 5px 5px;
        border: 1px solid #F2F2F2;
        padding: 10px;
        box-sizing: border-box;

        .nrname {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #9FAFB8;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .nrname1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          margin-top: 10px;
          text-align: left;
          white-space: nowrap;
        }
      }

      .qrbtnbox {
        margin: auto;
        margin-top: 80px;
        padding-left: 30px;
        box-sizing: border-box;
        padding-right: 30px;
        width: 315px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #5AA7F7;
        font-weight: bold;
        font-size: 16px;
        color: #5AA7F7;
        line-height: 40px;
        text-align: center;
      }

      .btnleft {
        width: 150px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #5AA7F7;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #5AA7F7;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .btnright {
        width: 150px;
        height: 40px;
        background: #5AA7F7;
        box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
        border-radius: 25px 25px 25px 25px;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-left: 16px;
      }
    }
  }

  .aiReport {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);

    .gbbox {
      background-color: #FFF;
      border-radius: 10px;
      position: relative;
      width: 100%;
      height: 100%;

      .gb {
        position: absolute;
        width: 15px;
        height: 15px;
        right: 15px;
        top: 15px;
      }
    }

    .qrbox {
      margin: auto;
      transform: translate(0%, 20%);
      border-radius: 7px;
      width: 927px;
      height: 558px;

      .qrtitle {
        width: 100%;
        height: 46px;
        line-height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        padding-left: 20px;
        box-sizing: border-box;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: #D9EBFF;
        border-radius: 10px 10px 0px 0px;
      }

      .qrfilename {
        display: flex;
        height: 64px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        margin: 20px 20px 16px 16px;
        box-sizing: border-box;

        .fileimg {
          padding: 10px;
          width: 44px;
          height: 44px;
        }

        .filename {
          font-size: 14px;
          color: #000000;
          line-height: 64px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .nrbox {
        margin-top: 20px;
        box-sizing: border-box;
        padding-left: 15px;
        padding-right: 15px;
        width: 100%;
        display: flex;

        .nrboxleft {
          margin-left: 5px;
          width: 55px;

          .qmylogo {
            width: 44px;
            height: 44px;
            border-radius: 99px;
          }


        }

        .nrboxright {
          flex: 1;

          .name {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #666666;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .content {
            margin-top: 10px;
            height: 360px;
            width: 100%;
            overflow-y: scroll;
            background-color: #F7F7F7;
            border-radius: 10px 10px 10px 10px;
            padding: 20px;
            box-sizing: border-box;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 32px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }


        }

        .fx {
          margin-left: 10px;
          margin-top: 30px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .movePop {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);

    .mp_box {
      width: 495px;
      height: 584px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      margin: 20px auto;


      .mpb_top {
        width: 100%;
        height: 60px;
        text-align: center;
        font-weight: 500;
        font-size: 21px;
        color: #000000;
        position: relative;
        line-height: 60px;

        img {
          position: absolute;
          right: 15px;
          top: 15px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }

      .mpb_back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        color: #A6B0BA;
        cursor: pointer;
        margin: 25px 0;
        box-sizing: border-box;
        padding: 0 18px;

        img {
          width: 9px;
          height: 15px;
          margin-right: 5px;
        }
      }

      .mpb_list {
        width: 100%;
        height: 350px;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 18px;

        .pbl_item {
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 21px;
          color: #000000;
          user-select: none;
          cursor: pointer;

          img {
            width: 58px;
            height: 58px;
            margin-right: 13px;
          }
        }
      }

      .mpb_bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;

        .pbb_btn {
          width: 198px;
          height: 53px;
          background: #FFFFFF;
          border-radius: 33px 33px 33px 33px;
          border: 1px solid #5AA7F7;
          font-weight: bold;
          font-size: 21px;
          color: #5AA7F7;
          text-align: center;
          line-height: 53px;
          user-select: none;
          cursor: pointer;
        }

        .pbb_btn1 {
          width: 198px;
          height: 53px;
          background: #5AA7F7;
          box-shadow: 0px 8 20px 0px rgba(29, 151, 239, 0.21);
          border-radius: 33px 33px 33px 33px;
          font-weight: bold;
          font-size: 21px;
          color: #FFFFFF;
          text-align: center;
          line-height: 53px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }


  .updateUrlandReportName {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);



    .qrbox {
      margin: auto;
      transform: translate(0%, 70%);
      background-color: #FFFFFF;
      border-radius: 7px;
      width: 375px;
      height: auto;
      padding-bottom: 15px;

      .esc {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        z-index: 4;
      }

      .gbbox {
        position: relative;
        width: 100%;
        height: 100%;

        .gb {
          position: absolute;
          width: 15px;
          height: 15px;
          right: 15px;
          top: 15px;
        }

        .qrtitle {
          width: 100%;
          height: 46px;
          line-height: 46px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .input {
          margin-top: 10px;
          margin-bottom: 20px;
          margin-left: 15px;
          width: 345px;
          height: auto;
          /* 高度自适应（如果不使用 rows 和 cols） */
          border: none;
          /* 去掉默认边框 */
          outline: none;
          /* 去掉焦点时的轮廓（可选） */
          resize: none;
          /* 禁止调整大小 */
        }
      }


      .qrfilename {
        display: flex;
        height: 64px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        margin: 20px 20px 16px 16px;
        box-sizing: border-box;

        .fileimg {
          padding: 10px;
          width: 44px;
          height: 44px;
        }

        .filename {
          font-size: 14px;
          color: #000000;
          line-height: 64px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .qcode {
        width: 160px;
        height: 160px;
        margin-left: 107px;
      }

      .qrbtnbox {
        margin-top: 80px;
        padding-left: 30px;
        box-sizing: border-box;
        padding-right: 30px;
        width: 100%;
        height: 40px;
        display: flex;
      }

      .btnleft {
        width: 345px;
        height: 50px;
        background: #5AA7F7;
        box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
        border-radius: 25px 25px 25px 25px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 50px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: auto;
      }

      .btnright {
        width: 150px;
        height: 40px;
        background: #5AA7F7;
        box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
        border-radius: 25px 25px 25px 25px;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-left: 16px;
      }
    }
  }

  .class_top {
    width: 100%;
    margin-bottom: 20px;

    .bottommenu {
      width: 100%;
      display: flex;
      align-items: center;
      // justify-content: center;
      cursor: pointer;

      .bit {
        opacity: 0.5 !important;
        cursor: not-allowed;
      }

      .bottommenu_item {
        width: fit-content;
        height: 40px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #399AFF;
        margin-right: 20px;

        .menu_img {
          width: 18px;
          height: 18px;
          filter: invert(48%) sepia(92%) saturate(2763%) hue-rotate(190deg) brightness(97%) contrast(101%);
        }

        .menu_txt {
          flex: 1;
          margin-left: 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
      }
    }

    .upload_box {
      display: flex;
      align-items: center;

      .topright_item {
        // margin-left: 20px;
        width: auto;
        padding-left: 20px;
        padding-right: 20px;
        background: #399AFF;
        border-radius: 8px;
        align-items: center;
        height: 40px;
        cursor: pointer;
        display: flex;

        .item_img {
          margin-right: 7px;
          width: 15px;
          height: 15px;
        }

        .item_txt {
          font-family: PingFang SC, PingFang SC;
          font-weight: 800;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .topright_item1 {
        margin-left: 20px;
        width: auto;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #399AFF;
        align-items: center;
        height: 40px;
        cursor: pointer;
        display: flex;
        padding-left: 20px;
        padding-right: 20px;
        margin-right: 15px;

        .item_img {
          margin-right: 7px;
          width: 15px;
          height: 15px;
        }

        .item_txt {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #399AFF;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }

  .clasalist {
    width: 100%;
    height: 34px;
    display: flex;
    border-top: 1px solid #F5F5F5;
    border-bottom: 1px solid #F5F5F5;

    background: #E9EDF7;


    .ztList {
      flex: 1;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 34px;
      font-style: normal;
      text-transform: none;
      display: flex;
      align-items: center;
    }

    .jtimg {
      margin-top: 10px;
      margin-left: 20px;
      width: 9px;
      height: 13px;
      cursor: pointer;
    }

    .jtimg1 {
      margin-right: 20px;
      margin-top: 10px;
      width: 15px;
      height: 15px;
    }

  }

  .dian {
    width: 100%;
    margin: 10px 0;

    display: flex;
  }

  .d2 {
    margin-right: 20px;
    width: 72px;
    height: 32px;
    background: #000000;
    border-radius: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    cursor: pointer;

  }

  .d1 {
    margin-right: 20px;
    width: 72px;
    height: 32px;
    background: #f2f2f2;
    border-radius: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
  }

  .title_box {
    margin-bottom: 18px;
    margin-top: 18px;
    width: 100%;
    height: auto;
    display: flex;

    .title {
      flex: 1;
      font-size: 20px;
      color: #000000;
      font-weight: bold;
      line-height: 20px;
      margin-left: 20px;
      margin-right: 20px;
      text-align: left;
      font-style: italic;
    }

    .diand {
      margin-right: 20px;
      display: flex;
      width: 50rpx;
    }


    .d3 {
      margin-top: 5px;
      margin-right: 5px;
      width: 8px;
      height: 8px;
      background: #eaeaea;
      border-radius: 4px 4px 4px 4px;
    }
  }

  .list::-webkit-scrollbar {
    display: none;
  }

  .list {
    position: relative;
    width: 100%;
    height: 0px;
    flex: 1;
    box-sizing: border-box;
    padding: 20px;
    overflow-y: scroll;

    .head {
      display: flex;
      width: 100%;
      height: 20px;

      .head_left {
        width: 100%;
        height: 20px;
        display: flex;

        .select {
          width: 20px;
          height: 20px;
          cursor: pointer;

        }

        .zw {
          margin-left: 20px;
          margin-right: 20px;
          width: 44px;
          height: 20px;
        }

        .t1 {
          flex: 1;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .t2 {
          width: 122px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

    }

    .item {
      margin-top: 20px;
      display: flex;
      width: 100%;
      height: 44px;
      cursor: pointer;
      user-select: none;

      .head_left {
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;

        .select {
          margin-top: 10px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        .zw {
          margin-left: 20px;
          margin-right: 20px;
          width: 44px;
          height: 44px;
        }

        .t1 {
          width: 400px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
          // line-height: 44px;
          text-align: left;
        }

        .item_tag {
          border: 1px solid #5aa7f7;
          border-radius: 5px;
          padding: 3px;
          height: 12px;
          margin-left: 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #5aa7f7;
          text-align: center;
          line-height: 12px;
        }

        .t2 {
          width: 122px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #565656;
          line-height: 44px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

    }

  }



}
</style>
